var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 0V0.722222H0V2.16667H0.75V11.5556C0.75 11.9386 0.908035 12.306 1.18934 12.5769C1.47064 12.8478 1.85218 13 2.25 13H9.75C10.1478 13 10.5294 12.8478 10.8107 12.5769C11.092 12.306 11.25 11.9386 11.25 11.5556V2.16667H12V0.722222H8.25V0H3.75ZM2.25 2.16667H9.75V11.5556H2.25V2.16667ZM3.75 3.61111V10.1111H5.25V3.61111H3.75ZM6.75 3.61111V10.1111H8.25V3.61111H6.75Z",
    fill: "#959CA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashModal);
export default __webpack_public_path__ + "static/media/trashModal.9d6af7ec878bbb9b7b99700816075bbd.svg";
export { ForwardRef as ReactComponent };